import { formatMileage } from "./number_helpers"
import { generateHashtag } from "./text_helpers"

export const generateStockText = stock => {
  if (!stock || typeof stock !== "object") return "No stock data available"

  const safe = value =>
    value?.name?.trim?.() ||
    (typeof value === "string" ? value.trim() : value) ||
    "-"

  return `
🚗 ${safe(stock.brand)} ${safe(stock.model)} ${safe(stock.package)} ${safe(
    stock.engine_type
  )} ${safe(stock.year)} ${safe(stock.exterior_color)}

📦 Package: ${safe(stock.package)}  
📅 Year: ${safe(stock.year)}  
⚙️ Engine CC: ${safe(stock.engine_c_c)}  
🔄 Transmission: ${safe(stock.transmission)}  
⛽ Fuel Type: ${safe(stock.fuel_type)}  
🔑 Key Type: ${safe(stock.key_type)}  
🎨 Color: ${safe(stock.exterior_color)} | Interior: ${safe(
    stock.interior_color
  )}  
🏆 Auction Grade: ${safe(stock.auction_grade)}  
📏 Mileage: ${formatMileage(stock.mileage)}  
🚪 Doors: ${stock.doors || "-"} | 💺 Seats: ${stock.seats || "-"}  
🛞 Tire Size: ${stock.tire_size || "-"}  

🗂 Stock ID: ${stock.stock_id || "-"}  
🔧 Chassis Code: ${safe(stock.chassis_code)}  
🛠 Engine Code: ${safe(stock.engine_code)}  
📍 Location: ${safe(stock.location)}  

${stock.stock_id ? generateHashtag(stock.stock_id) : ""}
  `.trim()
}

export const buildVehicleOptionLabel = vehicle => {
  if (!vehicle || typeof vehicle !== "object") return ""

  const text = value =>
    value?.name?.trim?.() ||
    (typeof value === "string" ? value.trim() : "") ||
    ""

  const primary = [vehicle.stock_id, vehicle.full_chassis].filter(Boolean)

  const mileage = vehicle.last_movement_mileage ?? vehicle.mileage
  const auctionGrade = text(vehicle.auction_grade)

  const secondary = [
    text(vehicle.brand),
    text(vehicle.model),
    text(vehicle.package),
    text(vehicle.engine_type),
    text(vehicle.exterior_color),
    text(vehicle.year),
    mileage != null ? formatMileage(mileage) : "",
    auctionGrade ? `Grade ${auctionGrade}` : "",
  ].filter(Boolean)

  const label = primary.join(" - ")
  return secondary.length ? `${label} | ${secondary.join(" ")}` : label
}

// Heading: stock id + full chassis, for structured (heading/subheading) option displays
export const buildVehicleHeading = vehicle => {
  if (!vehicle || typeof vehicle !== "object") return ""
  return [vehicle.stock_id, vehicle.full_chassis].filter(Boolean).join(" - ")
}

// Subheading: model, color, year, mileage, auction grade, for structured option displays
export const buildVehicleSubheading = vehicle => {
  if (!vehicle || typeof vehicle !== "object") return ""

  const text = value =>
    value?.name?.trim?.() ||
    (typeof value === "string" ? value.trim() : "") ||
    ""

  const mileage = vehicle.last_movement_mileage ?? vehicle.mileage
  const auctionGrade = text(vehicle.auction_grade)

  return [
    text(vehicle.model),
    text(vehicle.exterior_color),
    text(vehicle.year),
    mileage != null ? formatMileage(mileage) : "",
    auctionGrade ? `Grade ${auctionGrade}` : "",
  ]
    .filter(Boolean)
    .join(" • ")
}

export const generateStockTitle = stock => {
  if (!stock || typeof stock !== "object") return ""

  const getName = key => stock?.[key]?.name?.trim?.() || ""

  const parts = [
    getName("brand"),
    getName("model"),
    getName("engine_type"),
  ].filter(Boolean) // removes empty values

  return parts.join(" ")
}
